import React from 'react';

export const pricing = {
  id: 'billing-pricing',
  title: 'Pricing and Credits',
  description: 'Breakdown of credit costs, packages, and billing information.',
  category: 'billing',
  lastUpdated: '2025-10-15',
  // Updated pricing as of 2025-10-15
  tags: ['pricing', 'credits', 'packages'],
  content: () => (
    <div>
      <div className="space-y-6">
        <p className="text-muted-foreground leading-relaxed">
          The pricing is based on a simple credit system where each compression costs 1 credit. 
          I offer competitive rates with bulk discounts for larger packages.
        </p>
        
                  <div>
            <h2 className="text-xl font-semibold text-foreground mb-3">Credit System</h2>
            <p className="text-muted-foreground leading-relaxed mb-3">
              Every successful compression job consumes exactly 1 credit, regardless of:
            </p>
            <ul className="list-disc list-inside text-muted-foreground space-y-2 ml-4">
            <li>File size (up to the 500MB limit)</li>
              <li>Compression settings used</li>
              <li>Output file size</li>
              <li>Processing time</li>
            </ul>
          </div>
        <div>
          <h2 className="text-xl font-semibold text-foreground mb-3">Credit Packages</h2>
          <div className="bg-background-elevated rounded-lg p-4 space-y-3">
            <div className="flex justify-between items-center">
              <span className="text-foreground font-medium">100 Credits</span>
              <span className="text-accent font-medium">$9.75</span>
            </div>
            <div className="flex justify-between items-center">
              <span className="text-foreground font-medium">250 Credits</span>
              <span className="text-accent font-medium">$20.99</span>
            </div>
            <div className="flex justify-between items-center">
              <span className="text-foreground font-medium">500 Credits</span>
              <span className="text-accent font-medium">$39.99</span>
              <span className="bg-primary text-primary-foreground text-xs px-2 py-1 rounded ml-2">Most Popular</span>
            </div>
          </div>
          <p className="text-muted text-sm mt-3">
          </p>
        </div>
        
        <div>
          <h2 className="text-xl font-semibold text-foreground mb-3">Free Credits</h2>
          <p className="text-muted-foreground leading-relaxed">
            New users receive 1 free credit to try the service. This credit never expires 
            and can be used just like purchased credits.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold text-foreground mb-3">Payment Processing</h2>
          <p className="text-muted-foreground leading-relaxed">
            All payments are securely processed by <a href="https://stripe.com" target="_blank" rel="noopener noreferrer" className="text-accent hover:text-accent/90">Stripe</a>.
            I offer a 30-day money-back guarantee on all credit purchases. If you're not satisfied with the service, 
            contact me at <a href="mailto:stan@compress-glb.com" className="text-accent hover:text-accent/90">stan@compress-glb.com</a> for a full refund.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold text-foreground mb-3">Need Help?</h2>
          <p className="text-muted-foreground leading-relaxed">
            Have questions about pricing or billing? Feel free to reach out to{' '}
            <a href="mailto:stan@compress-glb.com" className="text-accent hover:text-accent/90">stan@compress-glb.com</a>
            {' '}for assistance.
          </p>
        </div>
      </div>
    </div>
  )
};